import { IDateRange } from "@/shared";
import {
  addDays,
  endOfDay,
  endOfToday,
  startOfDay,
  startOfToday,
  startOfMonth,
  endOfMonth,
} from "date-fns";
import { DateFormatPreference } from "@/enums/date-format";
import { DEFAULT_DATE_FORMAT_PREFERENCE } from "@/enums/date-format";
import { formatDateFromDate } from "@/utils/date-format-config";

const TODAY_DATE_RANGE: IDateRange = {
  startDate: startOfToday(),
  endDate: endOfToday(),
};

const TOMORROW_DATE_RANGE: IDateRange = {
  startDate: startOfDay(addDays(new Date(), 1)),
  endDate: endOfDay(addDays(new Date(), 1)),
};

const THIS_MONTH_DATE_RANGE: IDateRange = {
  startDate: startOfMonth(new Date()),
  endDate: endOfMonth(new Date()),
};

const dateStringFormat = (
  inputDate: Date,
  preference: DateFormatPreference = DEFAULT_DATE_FORMAT_PREFERENCE,
): string => formatDateFromDate(inputDate, preference);

export {
  TODAY_DATE_RANGE,
  TOMORROW_DATE_RANGE,
  THIS_MONTH_DATE_RANGE,
  dateStringFormat,
};
